export default __webpack_public_path__ + "static/iaip-1f78ce2625b767102e6d1707f0132ff6.webp";